import { CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer'
import { CSS3DObject } from 'three/examples/jsm/renderers/CSS3DRenderer'

export const createLabel = (dom: HTMLElement) => {
  return new CSS2DObject(dom)
}

export const create3DLabel = (dom: HTMLElement) => {
  return new CSS3DObject(dom)
}
